<h1 mat-dialog-title i18n="NotificationShowMoreDialog|Notification Show More Dialog Title@@notificationShowMoreDialog_title">Detalhes da Notificação</h1>
<div mat-dialog-content>
  {{notification.content}}
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions style="margin-top: 10px;">
  <span class="spacer"></span>
  <button mat-raised-button (click)="onClose()" i18n="NotificationShowMoreDialogClose|Notification Show More Dialog Close@@notificationShowMoreDialog_close">Sair</button>
</div>
